export { SelectIndicatorsComponent } from './lib/select-indicators/select-indicators.component';
export { ListIndicatorsComponent } from './lib/list-indicators/list-indicators.component'
export * from './lib/indicators-select.module';
